<div class="p-fluid">
  <div
    *ngIf="!canDelete"
    class="field">
    <p-selectButton
      [options]="mainSmsOptions"
      [(ngModel)]="sms.type"
      (ngModelChange)="changeType()"
      styleClass="shadow-none">
    </p-selectButton>
  </div>

  <div class="field">
    <label class="font-medium required-field">Имя отправителя</label>
    <crm-input-text
      [(value)]="sms.sender"
      class="w-full"
      [isError]="$any(errors?.sender)"></crm-input-text>
    <small
      *ngIf="errors?.sender"
      class="p-error">
      {{ errors.sender | join }}
    </small>
  </div>

  <ng-container *ngIf="sms.type === MainSmsIntegrationTypeEnum.SMS">
    <div class="field">
      <label class="font-medium required-field">Проект</label>
      <crm-input-text
        [(value)]="sms.project"
        class="w-full"
        [isError]="$any(errors?.project)"></crm-input-text>
      <small
        *ngIf="errors?.project"
        class="p-error">
        {{ errors.project | join }}
      </small>
    </div>

    <div class="field">
      <label class="font-medium required-field">API-key</label>
      <crm-input-text
        [(value)]="sms.apiKey"
        class="w-full"
        [isError]="$any(errors?.apiKey)"></crm-input-text>
      <small
        *ngIf="errors?.apiKey"
        class="p-error">
        {{ errors.apiKey | join }}
      </small>
    </div>
  </ng-container>

  <ng-container *ngIf="sms.type === MainSmsIntegrationTypeEnum.EMAIL">
    <div class="field">
      <label class="font-medium required-field">Почты</label>
      <p-chips
        [(ngModel)]="sms.emails"
        [addOnBlur]="true"
        [allowDuplicate]="false"
        [class]="errors?.emails ? ' ng-invalid ng-dirty' : ''"
        [styleClass]="errors?.emails ? ' ng-invalid ng-dirty' : ''"
        separator=","
        placeholder="test@mail.ru, test2@ya.ru"></p-chips>
      <small
        *ngIf="errors?.emails"
        class="p-error">
        {{ errors.emails | join }}
      </small>
    </div>

    <div class="field">
      <label class="font-medium required-field">API-key</label>
      <crm-input-text
        [(value)]="sms.mailingApiKey"
        class="w-full"
        [isError]="$any(errors?.mailingApiKey)"></crm-input-text>
      <small
        *ngIf="errors?.mailingApiKey"
        class="p-error">
        {{ errors.mailingApiKey | join }}
      </small>
    </div>
  </ng-container>
</div>

<div class="mt-2">
  <div
    class="flex flex-wrap gap-3"
    [class.justify-content-center]="!canDelete"
    [class.justify-content-between]="canDelete">
    <button
      *ngIf="!canDelete"
      pButton
      [label]="saveButtonLabel"
      class="p-button-success"
      style="min-width: 120px !important; max-width: 120px !important"
      (click)="onSave(sms)"></button>

    <button
      *ngIf="canDelete"
      pButton
      [label]="saveButtonLabel"
      class="p-button-success"
      (click)="onSave(sms)"></button>

    <button
      *ngIf="canDelete"
      pButton
      label="Удалить"
      class="p-button-danger p-button-text"
      (click)="delete.emit(sms)"></button>
  </div>
</div>
